import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, List, Row } from 'antd';
import { ModalEditLoopItem } from './ModalLoopItem';
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';
import { useNotifications } from '../../../hooks/useNotifications';
import { ActionButton } from '../../incidentForm/fields/style';

export const LoopComponent = ({ nodeHierarchy = [], field, value, onChange, renderFormItems, disabledField }) => {
  const { translate: t } = useDictionaryTranslation();
  const { showConfirmNotification } = useNotifications();
  const [loopItems, setLoopItems] = useState(Array.isArray(value) ? value : []);
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState({ index: loopItems.length, title: field.label });

  const selectLoopItem = (itemIndex) => {
    setSelectedItem({
      index: itemIndex,
    });
  };

  const updateValue = (newValue) => {
    // checkError(newValue);
    onChange(newValue);
    setLoopItems(newValue);
  };

  const saveItemValues = (values = []) => {
    let newItems;
    const newItem = values;
    if (selectedItem.index >= loopItems.length) {
      newItems = [...loopItems, newItem];
    } else {
      newItems = loopItems.map((item, index) => (index === selectedItem.index ? newItem : item));
    }
    updateValue(newItems);
  };

  const removeItem = (itemIndex) => {
    const newItems = loopItems.filter((_, index) => index !== itemIndex);
    updateValue(newItems);
  };

  const openModal = (itemIndex = loopItems.length) => {
    selectLoopItem(itemIndex);
    setShowModal(true);
  };

  const closeModal = ({ saveValues = false, values } = {}) => {
    if (saveValues) saveItemValues(values);
    setShowModal(false);
  };

  const getItemHandler = (itemIndex) => () => openModal(itemIndex);

  const getRemoveItemHandler = (itemIndex) => () => {
    showConfirmNotification({
      title: 'areYouSure',
      content: 'itemWillBeRemoved',
      onOk: () => {
        removeItem(itemIndex);
      },
    });
  };

  return (
    <>
      <List>
        {loopItems.map((_, index) => (
          <List.Item
            key={index}
            actions={[
              <ActionButton
                type="secondary"
                onClick={getItemHandler(index)}
                icon={<EditOutlined />}
                disabled={disabledField}
              />,
              <ActionButton
                type="danger"
                onClick={getRemoveItemHandler(index)}
                icon={<DeleteOutlined />}
                disabled={disabledField}
              />,
            ]}
          >
            <p>{t('itemNumberN', { n: index + 1 })}</p>
          </List.Item>
        ))}
      </List>

      <Row justify="end">
        <Button type="primary" onClick={getItemHandler(loopItems.length)} disabled={disabledField}>
          {t('addItem')}
        </Button>
      </Row>

      {showModal ? (
        <ModalEditLoopItem
          title={`${field.label}: ${t('itemNumberN', { n: (selectedItem?.index ?? 0) + 1 })}`}
          fields={field.list}
          values={loopItems[selectedItem?.index]}
          renderFields={renderFormItems}
          show={showModal}
          handleClose={closeModal}
          nodeHierarchy={[
            ...nodeHierarchy,
            {
              idInput: field.idInput,
              index: selectedItem?.index,
            },
          ]}
        />
      ) : null}
    </>
  );
};

export default LoopComponent;

LoopComponent.propTypes = {
  field: PropTypes.shape({
    idInput: PropTypes.string,
    label: PropTypes.string,
    obligatory: PropTypes.bool,
    list: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        label: PropTypes.string,
        idInput: PropTypes.string,
      }),
    ),
  }),
  value: PropTypes.array,
  nodeHierarchy: PropTypes.array,
  onChange: PropTypes.func,
  renderFormItems: PropTypes.func,
  disabledField: PropTypes.bool,
};
